import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-check-token',
  templateUrl: './check-token.component.html',
  styleUrls: ['./check-token.component.scss']
})
export class CheckTokenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    console.log('token checked');
  }

}
